import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";

const formatEnds = (expiresAt) => new Date(expiresAt).toLocaleString([], { dateStyle: "medium", timeStyle: "short" });

// Contact-details controls for the contact's active WhatsApp Web link (docs/WHATSAPP_WEB_HANDOFF_PLAN.md, section 6).
// Reset makes an opened link usable again (same expiry; the contact's current browser chat ends). Revoke ends the link and any
// open chat for good, so it asks twice because the contact loses the conversation in the browser.
const WhatsAppWebLinkActions = ({ status, onReset, resetting, onRevoke, revoking }) => {
  const [confirming, setConfirming] = useState(false);
  if (!status) return null;

  const headline = status.opened ? "Chat is open" : "Link sent, not opened yet";
  const detail = status.neverExpires ? "never expires" : `ends ${formatEnds(status.expiresAt)}`;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
      <Typography sx={{ fontSize: "0.8125rem" }}>
        {headline} <Typography component="span" sx={{ fontSize: "0.8125rem", color: "text.secondary" }}>· {detail}</Typography>
      </Typography>
      {confirming ? (
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.75 }}>
          <Typography sx={{ fontSize: "0.8125rem", color: "text.secondary" }}>
            {status.opened ? "End this chat? The contact can no longer use the link." : "Cancel this link?"}
          </Typography>
          <Button size="small" color="error" disabled={revoking} onClick={() => { onRevoke(); setConfirming(false); }} sx={{ textTransform: "none" }}>
            {revoking ? "Ending…" : "Yes, end it"}
          </Button>
          <Button size="small" disabled={revoking} onClick={() => setConfirming(false)} sx={{ textTransform: "none" }}>
            Keep
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          {status.opened && (
            <Button size="small" variant="outlined" disabled={resetting} onClick={onReset} sx={{ textTransform: "none" }}>
              {resetting ? "Resetting…" : "Reset"}
            </Button>
          )}
          <Button size="small" variant="outlined" color="error" onClick={() => setConfirming(true)} sx={{ textTransform: "none" }}>
            Revoke
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default WhatsAppWebLinkActions;
